import { GridApi } from 'ag-grid-community';
import { AgGridColumn } from 'ag-grid-react';
import React, { FC, useCallback } from 'react';
import { useHistory } from 'react-router';
import { getProjectStatusUpdatesDetailUrl } from 'utils/urls';
import {
  TimeRenderer,
  AvatarRenderer,
  DraftRender,
  StatusUpdateTitleRenderer,
  NoUpdatesEmptyState,
  getPrivateRowStyles,
} from './renderers';
import { StatusUpdateFilters } from './status-update-tabs';
import { GridContainer, StyledGrid } from './styles';
import { FilteredUpdates } from '.';

interface StatusUpdateListProps {
  projectId: number;
  gridApi: GridApi | null;
  onGridReady: (params) => void;
  activetab: StatusUpdateFilters;
  setDrawerVisiblity: (state) => void;
  filteredUpdates: FilteredUpdates;
}
export const StatusUpdateList: FC<StatusUpdateListProps> = ({
  projectId,
  gridApi,
  activetab,
  setDrawerVisiblity,
  onGridReady,
  filteredUpdates,
}) => {
  const { push } = useHistory();
  const onRowClicked = useCallback(
    (e) => {
      const url = getProjectStatusUpdatesDetailUrl(
        projectId,
        e.data.statusUpdateId,
      );

      push(url);
      setDrawerVisiblity(true);
    },
    [projectId, push, setDrawerVisiblity],
  );

  const fitToScreen = () => gridApi?.sizeColumnsToFit();

  const isDraftEmpty = !!(
    activetab === StatusUpdateFilters.Drafts && filteredUpdates[activetab]
  );

  return (
    <GridContainer className="ag-theme-balham">
      <StyledGrid
        size="large"
        rowData={filteredUpdates[activetab]}
        defaultColDef={{
          filter: false,
          sortable: false,
          resizable: false,
          wrapText: true,
          suppressMovable: true,
          suppressMenu: true,
          editable: false,
          rowDrag: false,
          unSortIcon: true,
        }}
        getRowStyle={getPrivateRowStyles}
        immutableData
        onFirstDataRendered={fitToScreen}
        rowHeight={48}
        suppressContextMenu
        rowSelection="single"
        suppressCellSelection
        animateRows
        frameworkComponents={{
          DraftRender,
          TimeRenderer,
          AvatarRenderer,
          StatusUpdateTitleRenderer,
          NoUpdatesEmptyState,
        }}
        getRowNodeId={(d) => d.statusUpdateId}
        getDataPath={(d) => [d.statusUpdateId]}
        onGridReady={onGridReady}
        onRowClicked={onRowClicked}
        noRowsOverlayComponent="NoUpdatesEmptyState"
        noRowsOverlayComponentParams={{ isDraftEmpty }}
      >
        <AgGridColumn width={42} maxWidth={42} cellRenderer="AvatarRenderer" />
        <AgGridColumn width={430} cellRenderer="StatusUpdateTitleRenderer" />
        <AgGridColumn width={40} cellRenderer="DraftRender" />
        <AgGridColumn width={40} cellRenderer="TimeRenderer" />
      </StyledGrid>
    </GridContainer>
  );
};
